import { useIntl } from "react-intl";
import {
  Modal,
  Box,
  IconButton,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";

const BoxInModal = (props) => {
  const intl = useIntl();

  const modalStyle = {
    position: "relative",
    top: "40%",
    left: "45%",
    width: "60%",
    ml: "7%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 4,
    borderRadius: 2,
  };

  const { setLoading } = useLoading();

  const [boxInData, setBoxInData] = useState([]);
  const [boxInDetails, setBoxInDetails] = useState([]);
  const [columns, setColumns] = useState([]);

  const getBoxInData = async () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/boxIn")
      .then((response) => {
        setLoading(false);
        setBoxInData(response.data);

        var data = [];
        response.data.boxInDetails.map((x) => {
          var item = x;
          item.boxInId = x.boxBarcode + "-" + x.skuBarcode;
          data.push(item);
        });

        setBoxInDetails(data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "boxBarcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxInDetails.BoxBarcode" })}
          />
        ),
        flex: 1,
      },
      {
        field: "boxNumberOutOfTotal",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxInDetails.BoxNumber" })}
          />
        ),
        flex: 1,
      },
      {
        field: "skuBarcode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxInDetails.SkuBarcode" })}
          />
        ),
        flex: 1,
      },
      {
        field: "quantity",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "BoxInDetails.Quantity" })}
          />
        ),
        flex: 1,
      },
    ]);
  };

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getBoxInData();
      getColumns();
    }
  }, [props.openModal]);

  const handleClose = () => {
    props.handleCloseModal();
    setBoxInData([]);
    setBoxInDetails([]);
  };

  const getBoxInDataExtraction = async () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/boxIn/excel")
      .then((response) => {
        setLoading(false);
        window.open(response.data, "_blank");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid container>
          <Grid item md={6}>
        <PageHeader
          title={
            intl.formatMessage({ id: "BoxInDetails.Title" }) +
            " - " +
            boxInData.dossierKey
          }
        />
          </Grid>
          <Grid
            item
            md={6}
            sx={{ backgroundColor: "#bcb7b7", textAlign: "right" }}
          >
            <Button
              sx={{ color: "white" }}
              onClick={getBoxInDataExtraction}
              disableRipple={true}
            >
              {" "}
              [{intl.formatMessage({ id: "BoxInDetails.Extract" })}]{" "}
            </Button>
          </Grid>
        </Grid>

        {boxInData !== null && boxInData != [] ? (
          <CustomTable
            columns={columns}
            rows={boxInDetails}
            id={"boxInId"}
            rowHeight={50}
            headerHeight={50}
            tableHeight={420}
          />
        ) : (
          ""
        )}
      </Box>
    </Modal>
  );
};

export default BoxInModal;
